import React from "react";
import { Copy, Pencil, Play } from "lucide-react";
import { copyText, draftCode, draftName } from "./teacherMocksHelpers";

export default function TeacherDraftMockRow({ mock, onEdit, onPublish, isHighlighted }) {
  const code = draftCode(mock);

  return (
    <tr className={`tprof-draft-row${isHighlighted ? " tprof-draft-row--highlighted" : ""}`}>
      <td>
        <div className="tprof-draft-title-row">
          <p>{draftName(mock)}</p>
          <span>Rascunho</span>
        </div>
        <div className="tprof-draft-course-row">
          <p>{mock.course}</p>
        </div>
      </td>
      <td>
        <button type="button" className="tprof-draft-copy" onClick={() => copyText(code)}>
          {code}
          <Copy size={12} aria-hidden="true" />
        </button>
      </td>
      <td>{mock.createdAt}</td>
      <td>{mock.questions}</td>
      <td>
        <div className="tprof-draft-actions">
          {mock.questions > 0 && onPublish && (
            <button
              type="button"
              className="tprof-draft-publish"
              onClick={() => onPublish(mock)}
              title="Publicar simulado"
            >
              <Play size={12} aria-hidden="true" />
              Publicar
            </button>
          )}
          <button type="button" className="tprof-draft-edit" onClick={() => onEdit(mock)} title="Editar rascunho">
            <Pencil size={12} aria-hidden="true" />
            Editar
          </button>
        </div>
      </td>
    </tr>
  );
}
